import packageJson from "../../package.json";

export function resolveProductKey() {
  const envProduct = (process.env.VUE_APP_PRODUCT || "")
    .replace(/['"]/g, "")
    .trim()
    .toLowerCase();

  if (envProduct === "mixora" || envProduct === "opt") {
    return envProduct;
  }

  return packageJson.name === "mixora" ? "mixora" : "opt";
}

export function resolveSisterProductKey(productKey = resolveProductKey()) {
  return productKey === "opt" ? "mixora" : "opt";
}

export function resolveSisterProductUrl() {
  return (process.env.VUE_APP_SISTER_PRODUCT_URL || "")
    .replace(/['"]/g, "")
    .trim();
}
